import React from 'react'
import { Flex } from 'antd'
import classnames from 'classnames'
import { formatUsdAmount } from '@/shared/helpers/currency'
import { formatTokenAmount } from '@/shared/helpers/crypto'
import { mints } from '@/shared/constants/mints'
import { CryptoBalance } from '@/features/Wallets/wallet.types'
import styles from '../MobileTxRow.module.scss'
import { TransactionIcon } from './TransactionIcon'
import { TransactionDetails } from './TransactionDetails'

export function TransactionRow({ iconType, title, createdAt, status, amount, withoutDate, isError, onClick, type, mint }: {
  amount: CryptoBalance | string;
  createdAt: string;
  iconType: string;
  isError: boolean;
  onClick: () => void;
  status: string;
  title: string;
  type: string;
  withoutDate: boolean;
  mint?: string;
}) {
  return (
    <div className={classnames(styles.txRow)}>
      <Flex onClick={onClick} gap={12} align="center">
        <TransactionIcon
          type={status === 'IN_PROGRESS' ? 'IN_PROGRESS' : iconType}
          isLoading={status === 'IN_PROGRESS'}
          isError={isError}
        />
        <TransactionDetails
          title={title}
          createdAt={createdAt}
          status={status}
          withoutDate={withoutDate}
          isError={isError}
          txType={type}
        />
        <div className={styles.txAmount}>
          <p className={classnames(
            styles.txTokenAmount,
            iconType && iconType === 'CHANGE_BALANCE_UP' && styles.txGreen,
            iconType && iconType === 'CHANGE_BALANCE_DOWN' && styles.txRed,
            isError && styles.errorTxGrey,
          )}
          >
            {iconType && iconType === 'CHANGE_BALANCE_UP' && '+'}
            {typeof amount === 'string' ? `0 ${mints[mint]}` : formatTokenAmount(amount, true)}
          </p>
          <p className={classnames(styles.txUsdAmount, isError && styles.errorTxGrey)}>
            {typeof amount === 'string' ? '$0' : formatUsdAmount(amount.amount)}
          </p>
        </div>
      </Flex>
    </div>
  )
}
